
<template>
  <div class="rightContent">
    <!-- 公司信息 -->
    <template>
      <div class="header">
        <div class="title f_18 color_40 font_w_b">公司信息</div>
        <div class="tips f_12 color_60">完善后即可免费下载完整简历</div>
      </div>
      <div :class="{'brandInfo': brandDisabled}" class="dataForm w488">
        <div class="item flex" :class="[errorTips.name?'error':'']" >
          <div class="formTitle color_9c f_14">公司名称：</div>
            <div class="flex1 companyInput pr">
              <el-input :disabled="true" class="restInput f_14 color_40" placeholder="请输入你的公司名称" v-model="company_data.company_full_name" />
            </div>
        </div>
        <div class="item flex" :class="[errorTips.uniform_credit_code?'error':'']" >
          <div class="formTitle color_9c f_14">社会统一信用码：</div>

            <template v-if="!!company_data_copy.uniform_credit_code">
              <div class="flex1">
                <el-input :disabled="true" v-model="company_data.uniform_credit_code" placeholder="请填写社会统一信用代码" class="restInput f_14 color_40" />
              </div>
            </template>
            <template v-else>
              <div class="flex1">
                <el-input v-model="company_data.uniform_credit_code" placeholder="请填写社会统一信用代码" class="restInput f_14 color_40" @focus="inputFocus('uniform_credit_code')" maxlength="64" />
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.uniform_credit_code">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.uniform_credit_code}}</span>
                </div>
              </div>
            </template>

        </div>
        <div class="item flex" :class="[errorTips.company_nick_name?'error':'']">
          <div class="formTitle color_9c f_14">公司简称：</div>

          <template v-if="!!company_data_copy.company_nick_name">
            <div class="flex1">
              <el-input :disabled="true" v-model="company_data.company_nick_name" placeholder="请填写公司简称" class="restInput f_14 color_40" />
            </div>
          </template>
          <template v-else>
            <div class="flex1">
              <el-input v-model="company_data.company_nick_name" placeholder="请填写公司简称" class="restInput f_14 color_40" @focus="inputFocus('company_nick_name')" maxlength="10" />
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.company_nick_name">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.company_nick_name}}</span>
              </div>
            </div>
          </template>

        </div>
        <div class="item flex" :class="[errorTips.company_type?'error':'']" >
          <div class="formTitle color_9c f_14">公司类型：</div>

          <template v-if="!!company_data_copy.company_type">
            <div class="flex1">
              <el-select :disabled="true" v-model="company_data.company_type" placeholder="请选择公司类型" class="restInput f_14 color_40">
                <el-option
                  v-for="item in company_options.nature_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </template>
          <template v-else>
            <div class="flex1">
              <el-select v-model="company_data.company_type" @change="inputFocus('company_type')" placeholder="请选择公司类型" class="restInput f_14 color_40">
                <el-option
                  v-for="item in company_options.nature_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.company_type">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.company_type}}</span>
              </div>
            </div>
          </template>

        </div>
        <div class="item flex" :class="[errorTips.industry_type?'error':'']" >
          <div class="formTitle color_9c f_14">行业类型：</div>

          <template v-if="!!company_data_copy.industry_type">
            <div class="flex1">
              <el-select :disabled="true" v-model="company_data.industry_type" placeholder="请选择行业类型" class="restInput f_14 color_40">
                <el-option
                  v-for="item in company_options.industry_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
            </div>
          </template>
          <template v-else>
            <div class="flex1">
              <el-select v-model="company_data.industry_type" @change="inputFocus('industry_type')" placeholder="请选择行业类型" class="restInput f_14 color_40">
                <el-option
                  v-for="item in company_options.industry_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.industry_type">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.industry_type}}</span>
              </div>
            </div>
          </template>

        </div>
        <div class="item flex" :class="[errorTips.phase?'error':'']" >
          <div class="formTitle color_9c f_14">融资阶段：</div>

            <template v-if="!!company_data_copy.phase">
              <div class="flex1">
                <el-select :disabled="true" v-model="company_data.phase" placeholder="请选择融资阶段" class="restInput f_14 color_40">
                  <el-option
                    v-for="item in company_options.phase_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
              </div>
            </template>
            <template v-else>
              <div class="flex1">
                <el-select v-model="company_data.phase" placeholder="请选择融资阶段" class="restInput f_14 color_40" @change="inputFocus('phase')">
                  <el-option
                    v-for="item in company_options.phase_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.phase">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.phase}}</span>
                </div>
              </div>
            </template>

        </div>
        <div class="item flex" :class="[errorTips.size?'error':'']" >
          <div class="formTitle color_9c f_14">公司规模：</div>

            <template v-if="!!company_data_copy.size">
              <div class="flex1">
                <el-select :disabled="true" v-model="company_data.size" placeholder="请选择公司规模" class="restInput f_14 color_40">
                  <el-option
                    v-for="item in company_options.scale_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </template>
            <template v-else>
              <div class="flex1">
                <el-select v-model="company_data.size" placeholder="请选择公司规模" class="restInput f_14 color_40" @change="inputFocus('size')">
                  <el-option
                    v-for="item in company_options.scale_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.size">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.size}}</span>
                </div>
              </div>
            </template>

        </div>
        <div class="item flex" :class="[errorTips.company_website_url?'error':'']" >
          <div class="formTitle color_9c f_14">公司官网：</div>

            <template v-if="!!company_data_copy.company_website_url">
              <div class="flex1">
                <el-input :disabled="true" v-model="company_data.company_website_url" placeholder="https://hr.wondercv.com" class="restInput f_14 color_40" />
              </div>
            </template>
            <template v-else>
              <div class="flex1">
                <el-input v-model="company_data.company_website_url" placeholder="https://hr.wondercv.com" class="restInput f_14 color_40" @focus="inputFocus('company_website_url')" maxlength="64" />
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.company_website_url">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.company_website_url}}</span>
                </div>
              </div>
            </template>

        </div>
        <div class="item flex" :class="[errorTips.logo?'error':'']" >
          <div class="formTitle color_9c f_14 logoItem">公司logo：</div>
          <div class="flex1">
            <div class="uploadBox">
              <div class="upload pr">
                <input :disabled="!!company_data_copy.logo" type="file" class="avatar-uploader pa cursor_p" ref="fileUpload" accept="image/*" @change="fileUpload">
                <img v-if="company_data.logo" :src="`${company_data.logo}?x-oss-process=image/resize,w_200`" class="logo pa">
                <div class="uploadIcon text_center color_90 f_14" v-else>
                  <p class="iconfont iconupload"></p>
                  <p class="tipsName">上传头像</p>
                </div>
              </div>
              <!-- 错误提示 -->
            <div class="errorTipsDesc f_14" v-if="errorTips.logo">
              <span class="iconfont icontishi"></span>
              <span class="tipsName">{{errorTips.logo}}</span>
            </div>
            </div>
          </div>
        </div>
        <div class="item flex" :class="[errorTips.business_license?'error':'']" >
          <div class="formTitle color_9c f_14">营业执照：</div>
            <template>
              <div class="flex1">
                <div class="flex business">
                  <div class="flex1"> 
                    <p>点击上传：</p>
                    <div class="business-left">     
                      <div class="no-business" v-if="!company_data.business_license" >
                        <i class="iconfont iconydjczmsc"></i>
                        <p>支持jpg、png、jpeg等格式图片大小不超过10M</p>
                      </div>
                      <img v-if="company_data.business_license" :src="company_data.business_license" alt="">
                      <input :disabled="brandDisabled" type="file" class="avatar-uploader pa cursor_p" ref="fileUploadBusslicense" accept="image/*" @change="clickFileUploadBusslicense">
                    </div>
                  </div>
                  <div class="flex1">
                    <p>示例：</p>
                    <div class="business-right">
                      <img src="https://files.wondercv.com/PC/hr/onboarding/example.png" alt="">
                    </div>
                  </div>
                </div>  
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.business_license">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.business_license}}</span>
                </div>
              </div>
            </template>
        </div>
        <div class="item flex">
          <img class="becareful" src="https://files.wondercv.com/PC/hr/onboarding/notice.png" alt="">
        </div>
      </div>
      <div class="flex">
        <div class="goback" @click="goback">返回上一步</div>
        <div v-if="!brandDisabled" class="saveButton bg_current color_fff f_16 cursor_p text_center" @click="saveForm()">
          <span class="el-icon-loading" v-if="saveFormState"></span> 提交审核 
        </div>
      </div>
      
      <div v-if="brandDisabled" class="error-feedback f_14 cursor_p">
        <span @click="errorMessage()">信息错误反馈</span>
      </div>
    </template>
    <div class="dialog" v-show="showDialog">
      <div class="dialog-body">
        <div class="content-image">
          <vueCropper style="background: transparent;" ref="cropper" :img="company_data.business_license"
            :canMove="option.canMove"
            :autoCrop="option.autoCrop"
            :centerBox="option.centerBox"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"></vueCropper>
            <div class="bottom-btn">
              <div @click="showDialog = false">取消</div>
              <div @click="upload">确定</div>
            </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
  const oss = require('ali-oss');
  import { uuid } from 'vue-uuid';
  // 所有接口
  import actions from '@/actions/index'
  import { mapState, mapMutations } from 'vuex'
  import { legalUrl, dataURLtoBlob, blobToFile } from '@/utils/utils'
  import company_options from '@/utils/company_options'
  // import ReplaceCompanyDialog from './replaceCompanyDialog'
  
  export default {
    name: 'companyAudit',
    props: {
      firstFlag: {
        type: Boolean,
        default: false
      },
      company_name: {
        type: String
      },
      status: [Number,String],
      audit_id: [Number,String],
      email: {
        type: String
      }
    },
    components: {
      // ReplaceCompanyDialog
    },
    data() {
      return {
        imageTest: '',
        getCompanyDataState:false,//是否正在请求公司信息
        company:'',//公司名称
        company_options:{},
        saveFormState:false, //是否正在保存
        searchIngCompanyList:[],
        backTo:'',//保存之后返回
        edit:'', //是否编辑
        searchCompanyFocus:false, //是否ju jiao
        logoUrl:'https://logo.wondercv.com',//logo域名
        brandDisabled: false, // 公司是否绑定了品牌
        showDialog: false,
        ossTime: '',
        option: {
          img: '', // 裁剪图片的地址
          // info: true, // 裁剪框的大小信息
          // outputSize: 0.8, // 裁剪生成图片的质量
          // outputType: 'jpeg', // 裁剪生成图片的格式
          canScale: true, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 126, // 默认生成截图框宽度
          autoCropHeight: 210, // 默认生成截图框高度
          // fixedBox: true, // 固定截图框大小 不允许改变
          fixed: true, // 是否开启截图框宽高固定比例
          fixedNumber: [126,210], // 截图框的宽高比例
          full: true, // 是否输出原图比例的截图
          // canMoveBox: false, // 截图框能否拖动
          // original: false, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        },
        isFromQxx: true, // 判断是否来自企查查
        // 审核公司拷贝
        company_data_copy: {},
        // 审核公司
        company_data:{
          logo:"",
          company_full_name:"",
          company_nick_name:"",
          company_type:"",
          industry_type:"",
          phase:"",
          company_website_url:"",
          size_min:0,
          size_max:0,
          business_license:"",
          uniform_credit_code:"",
          is_qxx: true,
          size: '',
        },
        errorTips:{ //错误提示
          logo:'',
          company_full_name:'',
          company_nick_name:'',
          company_type:'',  //公司类型
          size:'', //公司规模
          industry_type:'', //行业类型
          phase:'', //融资阶段
          company_url:'',//公司网址
          uniform_credit_code:"", // 统一信用代码
          business_license:"", // 营业执照
        },
      }
    },
    created() {
      //读取保存之后返回的地址
      let { backTo='', edit } = this.$route.query;
      // 是否从url传递的参数
      this.backTo = backTo;
      this.edit = edit;
      this.company_options = company_options;
      this.getOssData()
      if(this.company_name) {
        // 去企查查查询公司信息
        let loadLoading =  this.$message({
          message: '正在加载',
          iconClass:'el-icon-loading',
          duration:0,
        });
        actions.company.get_qixxcompany_info({company_name: this.company_name}).then(res => {
          loadLoading.close()
          if(res.code == 1000 && res.data && res.data.is_qxx) {
            this.company_data = res.data
            this.company_data.size = (res.data.size_min && res.data.size_max) ? res.data.size_min + ',' + res.data.size_max : ''
            this.company_data_copy = JSON.parse(JSON.stringify(this.company_data)) // 公司对象拷贝，判断可不可编辑
          } else {
            this.company_data_copy = JSON.parse(JSON.stringify(this.company_data)) // 公司对象拷贝，判断可不可编辑
            this.company_data.company_full_name = this.company_name
            this.company_data.is_qxx = false
          }
        })
      }
      
      this.logoUrl = process.env.VUE_APP_ENV_TYPE === 'prod' ? 'https://logo.wondercv.com' : 'https://logo.wondercv.cn';
    },
    mounted () {
      // actions.company.get_company_companies('brand_dqRMsMFt82eAlppA',{type:'hr'})
    },
    computed: {
      ...mapState('block', ['ossOptions', 'userInfo']),
      showReplaceCompanyBtn () {
        return this.brandDisabled
      }
    },
    methods: {
      ...mapMutations('block',['toggleUserInfoState','updateOssOptions']),
      ...mapMutations('company',['updateCompanyData','updateCompanyTabIndex', 'updateBrandData']),
      goback(){
        this.$emit('goback')
      },
      getOssData(){
        actions.staticApi.get_oss_token({}).then(res=>{
        if(res.code === 1000){
          let { access_key_id, access_key_secret, expiration, request_id,security_token } = res.data;
            // accessKeyId: 'your access key',
            // accessKeySecret: 'your access secret',
            // bucket: 'your bucket name',
            // region: 'oss-cn-hangzhou'
            this.updateOssOptions({
              region: 'oss-cn-beijing',
              accessKeyId: access_key_id,
              accessKeySecret: access_key_secret,
              bucket: 'staging-wondercv-logo',
              stsToken: security_token
            })
            //十分钟重新获取一次
            let ossTimeIndex = 10;
            this.ossTime = setInterval(() => {
              if(ossTimeIndex<=0){
                //清除定时器
                clearInterval(this.ossTime);
                //重新获取oss参数
                this.getOssData();
              }
              ossTimeIndex-=1;
            }, 60*1000);
        }else{

        }
        })
      },

      // 裁剪上传
      async upload() {
        this.$refs.cropper.getCropData(async file => {
          // console.log(file);
          // this.$emit('uploadConfirm',file);
          var blob = dataURLtoBlob(file);
          const reader = new FileReader(blob);
          reader.readAsDataURL(blob);
          reader.onload = e =>{
            const store = oss(this.ossOptions);
            //调用
            var fileData = blobToFile(blob, imgName);
            let imgName = `${uuid.v1()}.${fileData.type.split('/')[1]}`
            let downloadLoading =  this.$message({
              message: '正在上传',
              iconClass:'el-icon-loading',
              duration:0,
            });
            store.put(`companies/${imgName}`, fileData).then((res) => {
              downloadLoading.close();
              if(res.res.statusCode===200){
                this.company_data.business_license = `${this.logoUrl}/${res.name}`
                this.$refs.fileUploadBusslicense.value = '';
                this.$message({
                  message: '上传成功',
                  type: 'success'
                });
                this.showDialog = false
              }else{
                this.$message({
                  message: '图片上传失败',
                  type: 'error'
                });
              }
            });
          }
       })
      },
      //上传之前验证
      beforeFileUploadlicense(file) {
        const fileTypes = 'image/png,image/jpeg,image/jpg'
        const isJPG = fileTypes.indexOf(file.type)>-1;
        const isLt4M = file.size / 1024 / 1024 < 10;
        if (!isJPG) {
          this.$message.error('上传公司凭证格式错误!');
          return false;
        }
        if (!isLt4M) {
          this.$message.error('上传公司公司凭证大小不能超过 10MB!');
          return false;
        }
        return true;
      },
      beforeFileUpload(file) {
        const fileTypes = 'image/png,image/gif,image/jpeg,image/tif,image/tiff,image/bmp,image/x-bmp'
        const isJPG = fileTypes.indexOf(file.type)>-1;
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传公司logo格式错误!');
          return false;
        }
        if (!isLt2M) {
          this.$message.error('上传公司logo大小不能超过 2MB!');
          return false;
        }
        return true;
      },
      //图片上传
      fileUpload(e){
        //清空错误提示
        this.errorTips.logo = '';
        // 获取图片base64
        let file = this.$refs.fileUpload.files[0]
        if(!this.beforeFileUpload(file)){
          this.$refs.fileUpload.value = '';
          return false;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e =>{
          const store = oss(this.ossOptions);
          let imgName = `${uuid.v1()}.${file.type.split('/')[1]}`
          //调用
          var blob = dataURLtoBlob(e.currentTarget.result);
          var fileData = blobToFile(blob, imgName);
          let downloadLoading =  this.$message({
            message: '正在上传',
            iconClass:'el-icon-loading',
            duration:0,
          });
          store.put(`companies/${imgName}`, fileData).then((res) => {
            downloadLoading.close();
            if(res.res.statusCode===200){
              this.company_data.logo = `${this.logoUrl}/${res.name}`
              this.$forceUpdate()
              this.$refs.fileUpload.value = '';
              this.$message({
                message: '上传成功',
                type: 'success'
              });
            }else{
              this.$message({
                message: '图片上传失败',
                type: 'error'
              });
            }
          });
        }
      },
      //凭证上传
      clickFileUploadBusslicense(e){
        // 清空错误信息
        this.errorTips.business_license = '';
        let file = this.$refs.fileUploadBusslicense.files[0]
        if(!this.beforeFileUploadlicense(file)){
          this.$refs.fileUploadBusslicense.value = '';
          return false;
        }
        let reader = new FileReader(file);
        reader.readAsDataURL(file);
        reader.onload = e => {
          // var blob = dataURLtoBlob(e.currentTarget.result);
          // let url = URL.createObjectURL(blob)
          // this.company_data.business_license = url
          // this.showDialog = true

          // 不裁剪上传
          const store = oss(this.ossOptions);
          let imgName = `${uuid.v1()}.${file.type.split('/')[1]}`
          //调用
          var blob = dataURLtoBlob(e.currentTarget.result);
          var fileData = blobToFile(blob, imgName);
          let downloadLoading =  this.$message({
            message: '正在上传',
            iconClass:'el-icon-loading',
            duration:0,
          });
          store.put(`companies/${imgName}`, fileData).then((res) => {
            downloadLoading.close();
            if(res.res.statusCode===200){
              this.company_data.business_license = `${this.logoUrl}/${res.name}`
              this.$forceUpdate()
              this.$refs.fileUpload.value = '';
              this.$message({
                message: '上传成功',
                type: 'success'
              });
            }else{
              this.$message({
                message: '图片上传失败',
                type: 'error'
              });
            }
          });
        }
        return
      },

      //【公司】搜索公司名称
      companySearch(queryString, cb) {
        //搜索词一致，不进行搜索
        this.company = queryString ? queryString.trim() : '';
        this.company_data.company_full_name = this.company;
        cb([]);
        if(!queryString || !queryString.trim().length){
          return false;
        }
        let query = {
          from:0,
          size:30,
          keyword:queryString
        }
        actions.company.get_company_name(query).then(res=>{
          if(res.code === 1000){
            let { companies } = res.data;
            this.searchIngCompanyList = JSON.parse(JSON.stringify(companies));
            //防止同指针，污染 searchIngCompanyList
            let companyList = [...companies];
            //拆分数据
            companyList.forEach((item,index)=>{
              let name = [item.full_name];
              item.name = item.full_name;
              if(item.full_name.indexOf(queryString)>-1){
                name = item.full_name.split(queryString).filter(sitem => sitem)
              }
              item.index = index;
              item.full_name = name
            })
            // 调用 callback 返回建议列表的数据
            cb(companyList.length ? companyList : [{token:''}]);
          }
        })
      },
       //【公司】失焦
      companyBlur(){
        setTimeout(() => {
          let { company_full_name } = this.company_data
          company_full_name = company_full_name.trim();

          if(this.getCompanyDataState || !company_full_name){
            return false;
          }
          if(company_full_name.length){
            let hasCompany = false;
            this.searchIngCompanyList && this.searchIngCompanyList.forEach(item=>{
              if(item.full_name === company_full_name){
                hasCompany = true;
                if(item.token !== this.company_data.token){
                  this.getCompanyData(item.token)
                }
              }
            })
            if(!hasCompany){
              this.company_data.company_full_name = '';
              this.searchIngCompanyList = []
            }
          }
          //是否聚焦公司输入框
          this.searchCompanyFocus = false;
        }, 200);
      },
      //重新获取公司信息
      getCompanyData(token, isBrandToken, callback){
        actions.company.get_company_companies(token,{type:'hr'}).then(res=>{
          if(res.code === 1000){
            let { company_website_url, company_website_url_hr, size_min, size_max, logo, logo_hr, description, description_hr, benefits, industry_id, industry_type } = res.data;
            //网址判断
            res.data.company_website_url_hr = company_website_url_hr || company_website_url || '';
            //logo判断
            res.data.logo_hr = logo_hr || logo || '';
            //描述判断
            res.data.description_hr = description_hr || description || '';
            //公司规模
            res.data.size = ''
            if(size_max){
              company_options.scale_options.forEach(item=>{
                if(size_max<=item.max && !res.data.size){
                  res.data.size = item.value
                }
              })
            }
            callback && callback(res.data)
            //重置错误提示
            this.errorTips = { //错误提示
              logo:'',
              name:'',
              company_type:'',  //公司类型
              scale:'', //公司规模
              industry_type:'', //行业类型
              phase:'', //融资阶段
              company_url:'',//公司网址
              description_hr:'',//描述
            }
          }
        }) 
      },
      //【公司】点击筛选项
      handleCompany(item) {
        if(!item.token){
          this.company_data.company_full_name = '';
          return false
        }
        this.company_data.company_full_name = item.name;
      },
      //取消错误提示
      inputFocus(type){
        this.errorTips[type] = ''
        if(type==='name'){
          //是否聚焦公司输入框
          // this.searchCompanyFocus = true;
        }
      },
      //提交审核
      async saveForm(){
        let { logo,company_full_name, business_license, company_nick_name, company_type, industry_type, phase, size, company_website_url, uniform_credit_code, size_min,size_max } = this.company_data;
        //是否聚焦公司输入框
        // console.log('点击了');
        // if(this.searchCompanyFocus){
        //   return false;
        // }
          let formState = true;
          if(!logo){
            this.errorTips.logo = '请上传公司logo';
            formState = false;
          }
          if(!company_full_name){
            this.errorTips.company_full_name = '请填写公司名称';
            formState = false;
          }
          if(!uniform_credit_code){
            this.errorTips.uniform_credit_code = '请填写社会统一信用码';
            formState = false;
          }
          if(!company_nick_name){
            this.errorTips.company_nick_name = '请填写公司简称';
            formState = false;
          }
          if(!company_type){
            this.errorTips.company_type = '请选择公司类型';
            formState = false;
          }
          if(!industry_type){
            this.errorTips.industry_type = '请选择行业类型';
            formState = false;
          }
          if(!phase){
            this.errorTips.phase = '请选择融资阶段';
            formState = false;
          }
          if(!size){
            this.errorTips.size = '请选择公司规模';
            formState = false;
          }
          if(company_website_url && !legalUrl(company_website_url)){
            this.errorTips.company_website_url = '请填写正确的公司官网地址';
            formState = false;
          }
          if(!business_license){
            this.errorTips.business_license = '请上传营业执照';
            formState = false;
          }
          if(!formState){
            return false;
          }
          size_min = Number(size.split(',')[0]);
          size_max = Number(size.split(',')[1]);
          this.company_data.size_min = size_min;
          this.company_data.size_max = size_max;
          
          if(this.saveFormState){
            return false;
          }
          let data = JSON.parse(JSON.stringify(this.company_data))
          data.status = this.status
          data.audit_id = this.audit_id
          if(!!this.email){
            data.cust_company_email = decodeURIComponent(this.email) 
          }
          this.saveFormState = true;
          actions.company.company_audit(data).then(res => {
            if(res.code == 1000) {
              this.$message.success('已提交公司审核')
              this.$router.push('/talent/recommend')
              // this.$emit('goback')
            } else {
              this.$message.error('提交审核失败')
            }
            this.saveFormState = false;      
          })
      },
      //重新上传
      resetData(){
        this.company_data = {
          logo:"",
          company_full_name:"",
          company_nick_name:"",
          company_type:"",
          industry_type:"",
          phase:"",
          company_website_url:"",
          size_min:0,
          size_max:0,
          business_license:"",
          uniform_credit_code:"",
          is_qxx:false
        }
      },
      // 弹出客服
      errorMessage () {
        let udesk_container = document.querySelector('#udesk_btn a')
        if(udesk_container!=null){
          udesk_container.click()
        }
      }
    },
    watch:{
      // companyData :{
      //   handler: function (val, oldVal) {
      //     if(val.token===this.company_data.token){
      //       let { logo_hr,company_full_name, company_nick_name, company_type, industry_id, phase, size, company_website_url_hr, description_hr } = this.company_data;
      //       if(logo_hr!=val.logo_hr || company_full_name!=val.company_full_name || company_nick_name!=val.company_nick_name || company_type!=val.company_type || industry_id!=val.industry_id || phase!=val.phase || size!=val.size || company_website_url_hr!=val.company_website_url_hr ||  description_hr!=val.description_hr){
      //         console.log('rightContent阻止更新')
      //         return false;
      //       }
      //     }
      //     this.company_data = JSON.parse(JSON.stringify(val));
      //     this.company = this.company_data.company_full_name;
      //   },
      //   deep: true
      // }

      // 页面禁止滚动
      showDialog(val,oldval){
        if(val){
          // 禁止页面滚动
          document.body.style.position = 'static'
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = 'auto'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './index.scss';
  .dialog{
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.4);
    top: 0;
    right: 0;
    position: fixed;
    z-index: 10;
    .dialog-body{
      width: 500px;
      height: 400px;
      background: #FFFFFF;
      border-radius: 6px;
      margin: auto;
      margin-top: 10%;
      .bottom-btn{
        display: flex;
        width: 200px;
        margin-top: 30px;
        margin-left: 57px;
        &>div{
          width: 84px;
          height: 36px;
          text-align: center;
          line-height: 36px;
          font-size: 14px;
          background: #FFFFFF;
          border-radius: 2px;
          cursor: pointer;
        }
        &>div:nth-of-type(1){         
          color: #606060;
          margin-right: 24px;
        }
        &>div:nth-of-type(2){
          background-color: #FF6644;
          color: #FFFFFF;
        }
      }
      .content-image{
        width: 306px; 
        height: 400px;
        position: relative;
        margin: auto;
      }
    }
  }
  /deep/ .company-name .el-input__inner:hover, .is-focus .el-input__inner, .el-input__inner:focus{
    border: 1px solid #ececec !important;
  }
  /deep/ .company-name .el-input.is-disabled .el-input__inner{
    background-color: #FAFBFD;
    color: #9C9C9C;
  }
  /deep/ .el-input.is-disabled .el-input__inner{
    color: #9c9c9c;
    background: #FAFBFD;
  }
</style>
